import 'flickity/css/flickity.css';
import 'flickity-fade/flickity-fade.css';
import Flickity from 'flickity';
import 'flickity-fade';
import 'fslightbox';
import LazyLoad from 'vanilla-lazyload';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);



setTimeout(() => {
  document.body.classList.add('start');
}, 150);
  setTimeout(() => {
    document.getElementById('loading').remove();
  }, 450);
// ─── Modal ────────────────────────────────────────────────────────────────────
let modalAnimating = false;
let modalOpener = null;
const modal = document.getElementById('modal');

function closeModal() {
    if (modalAnimating) return;
    modalAnimating = true;
    document.body.classList.remove('animate-modal');
    setTimeout(() => {
        document.body.classList.remove('open-modal');
        modalAnimating = false;
        // modalOpener?.focus();
        // modalOpener = null;
    }, 300);
}

document.addEventListener('click', e => {
    if (e.target.closest('.launch-modal') && !modalAnimating) {
        e.preventDefault();
        modalOpener = e.target.closest('.launch-modal');
        modalAnimating = true;
        document.body.classList.add('open-modal');
        modal.querySelector('.overflow-y-auto')?.scrollTo(0, 0);
        setTimeout(() => {
            document.body.classList.add('animate-modal');
            modalAnimating = false;
            modal.querySelector('button.close-modal')?.focus({ preventScroll: true });
        }, 10);
    }

    if (e.target.closest('.close-modal') && !modalAnimating) {
        closeModal();
    }
});

document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && document.body.classList.contains('open-modal')) {
        closeModal();
    }

    if (e.key === 'Tab' && document.body.classList.contains('open-modal')) {
        const focusable = [...modal.querySelectorAll('a, button, input, [tabindex]:not([tabindex="-1"])')];
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
            if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
            if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
    }
});
// ─────────────────────────────────────────────────────────────────────────────

// ─── Mobile nav ───────────────────────────────────────────────────────────────
const navToggleBtn = document.getElementById('nav-toggle-btn');
const mobileNav = document.getElementById('mobile-nav');

function closeMobileNav() {
    document.body.classList.remove('nav-open');
    navToggleBtn.setAttribute('aria-expanded', 'false');
    mobileNav.setAttribute('aria-hidden', 'true');
    mobileNav.querySelectorAll('.nav-mobile-link').forEach(a => a.setAttribute('tabindex', '-1'));
}

navToggleBtn?.addEventListener('click', () => {
    const isOpen = document.body.classList.toggle('nav-open');
    navToggleBtn.setAttribute('aria-expanded', isOpen);
    mobileNav.setAttribute('aria-hidden', !isOpen);
    mobileNav.querySelectorAll('.nav-mobile-link').forEach(a => {
        a.setAttribute('tabindex', isOpen ? '0' : '-1');
    });
});

document.addEventListener('click', e => {
    if (!document.body.classList.contains('nav-open')) return;
    const header = navToggleBtn.closest('header');
    const outsideHeader = !header.contains(e.target);
    const isLaunchModal = !!e.target.closest('.launch-modal');
    const isNavLink = !!e.target.closest('.nav-mobile-link');
    if (outsideHeader || isLaunchModal || isNavLink) {
        closeMobileNav();
    }
});
// ─────────────────────────────────────────────────────────────────────────────

history.scrollRestoration = "manual";
const savedScroll = sessionStorage.getItem("scrollPos");
if (!savedScroll) window.scrollTo(0, 0);



new LazyLoad({
    
});

// ─── Scrollspy ───────────────────────────────────────────────────────────────
const navLinks = [...document.querySelectorAll('header a[href^="#"]')];
const sectionIds = navLinks.map(a => a.getAttribute('href').slice(1));

function updateActiveNav() {
  const threshold = window.innerHeight * 0.4;
  let current = '';

  sectionIds.forEach(id => {
    const el = document.getElementById(id);
    if (el && el.getBoundingClientRect().top <= threshold) {
      current = id;
    }
  });

  navLinks.forEach(link => {
    const id = link.getAttribute('href').slice(1);
    link.classList.toggle('active', id === current);
  });
}
// ─────────────────────────────────────────────────────────────────────────────

let lastScrollY = window.scrollY;

window.addEventListener('scroll', () => {
  const y = window.scrollY;
  const nearFooter = y > document.documentElement.scrollHeight - window.innerHeight * 2;

  document.body.classList.toggle('scrolled', y > 50);

  if (nearFooter) {
    document.body.classList.add('scrolled-down');
    document.body.classList.remove('scrolled-up');
  } else {
    document.body.classList.toggle('scrolled-down', y > lastScrollY && y > 50);
    document.body.classList.toggle('scrolled-up', y < lastScrollY && y > 50);
  }

  lastScrollY = y;
  updateActiveNav();
});



// ─── Hero-section-2 entrance + spinners (standalone, no blob) ────────────
const kerryHeader = document.getElementById("kerry-header");

if (kerryHeader) {
  const spinner1 = document.getElementById("spinner-1");
  // const spinner2 = document.getElementById("spinner-2");
  const svgInner = kerryHeader.querySelector(".svg-inner");

  // Centre spinner-2 via GSAP so it owns all transforms (avoids CSS translate conflict)
  // gsap.set(spinner2, { xPercent: -50, yPercent: -50 });

  // Pulse tweens — different durations create natural phase drift
  const pulse1 = gsap.fromTo(spinner1,
    { scale: .7 },
    { scale: .76, duration: 2.5, ease: "sine.inOut", repeat: -1, yoyo: true, paused: true }
  );
  // const pulse2 = gsap.fromTo(spinner2,
  //   { scale: 0.55 },
  //   { scale: 0.60, duration: 3.2, ease: "sine.inOut", repeat: -1, yoyo: true, paused: true }
  // );

  // Scroll: scale both up and off-screen via the shared wrapper, also animate opacity 1→0
  const scrollTween = gsap.fromTo(svgInner,
    { scale: 1, rotation: 0 },
    { scale: 4, rotation: 120,
    ease: "none",
    scrollTrigger: {
      trigger: kerryHeader,
      start: "top top",
      pin: false,
      end: () => `+=${window.innerHeight}`,
      scrub: 1.5,
      // Animate opacity on the same scrub, but reach 0 sooner using the 'onUpdate' callback and progress
      onUpdate: self => {
        // Progress (0 to 1, how far the scroll animation is)
        // For example, have opacity reach 0 when progress is at 0.6:
        const p = self.progress;
        svgInner.style.opacity = Math.max(0, 1 - (p / 0.7));
      }
    },
    // Prevent GSAP from animating opacity itself
    // We'll handle opacity via the onUpdate above
    // (no "opacity" property here)
  });

  if (savedScroll) {
    sessionStorage.removeItem("scrollPos");
    requestAnimationFrame(() => window.scrollTo(0, parseFloat(savedScroll)));
    pulse1.play();
    // pulse2.play();
  } else if (window.scrollY === 0) {
    gsap.timeline({ delay: 0.3, onComplete: () => { pulse1.play(); } }) // pulse2.play(); } })
      .from("#initial-title",    { y: 40, opacity: 0, duration: .7, ease: "power3.out" })
      .from("#initial-subtitle", { y: 20, opacity: 0, duration: .6, ease: "power3.out" }, "-=0.5")
      .fromTo(spinner1, { scale: 0, rotation: -20, opacity: 0 }, { scale: .7,    rotation: 0, opacity: 1, duration: 1.2, ease: "back.out(1.4)" }, "-=0.2")
      // .fromTo(spinner2, { scale: 0, rotation:  20, opacity: 0 }, { scale: 0.55, rotation: 0, opacity: 1, duration: 1.2, ease: "back.out(1.4)" }, "-=0.9");
  } else {
    pulse1.play();
    // pulse2.play();
  }



  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      console.log('[resize] invalidating tweens + refreshing ScrollTrigger');
      pulse1.invalidate().restart();
      // pulse2.invalidate().restart();
      scrollTween.invalidate();
      ScrollTrigger.refresh();
      console.log('[resize] done');
    }, 200);
  });
}


// ─── Section header parallax ─────────────────────────────────────────────────
function initSectionHeaderParallax() {
  document.querySelectorAll('.section-header, .ection-header').forEach(section => {
    const bgImg      = section.querySelector('[data-src*="-bg"]');
    const personImgs = [...section.querySelectorAll('[data-src*="-person"]')];

    if (!bgImg && !personImgs.length) return;

    const stBase = {
      trigger: section,
      start: 'top bottom',
      end: 'top top',
      scrub: 1.2,
    };

    // Background moves faster — larger starting offset
    if (bgImg) {
      gsap.fromTo(bgImg,
        { y: 140 },
        { y: 0, ease: 'none', scrollTrigger: { ...stBase } }
      );
    }

    // Person layer moves slower — shallower starting offset
    personImgs.forEach(img => {
      gsap.fromTo(img,
        { y: 70 },
        { y: 0, ease: 'none', scrollTrigger: { ...stBase } }
      );
    });
  });
}

initSectionHeaderParallax();
// ─────────────────────────────────────────────────────────────────────────────

// Add hover event listeners to toggle 'button-hovered' on footer

document.addEventListener("DOMContentLoaded", function() {
  const footer = document.querySelector('footer');
  if (!footer) return;

  // Event delegation works even for dynamically added buttons
  footer.addEventListener('mouseover', function(e) {
    const abutton = e.target.closest('.abutton');
    if (abutton && footer.contains(abutton)) {
      footer.classList.add('footer-button-hovered');
    }
  });

  footer.addEventListener('mouseout', function(e) {
    const abutton = e.target.closest('.abutton');
    // Only remove if the mouse leaves the .abutton (not just a child)
    if (abutton && footer.contains(abutton)) {
      // Check if now hovered element is outside '.abutton'
      if (!abutton.contains(e.relatedTarget)) {
        footer.classList.remove('footer-button-hovered');
      }
    }
  });
});